import { IdentityPerson, IdentitySeason } from '@reg/shared/model';

/**
 * Model to hold Team data for wrestling. It's used for grouping/categorizing
 * wrestlers together onto a single team
 */
export class IdentityTeamRoster {
    public id: string = null;
    public identityTeamId: string = null;
    public athletes: IdentityPerson[] = [];
    public season: IdentitySeason = null;
    public displayName: string = null;

    private _name: string = null;
    set name(name: string) {
        this._name = name && name.trim();
    }

    get name(): string {
        return this._name;
    }

    public formatNameSeason(): string {
        if (this.season && this.season.name) {
            return `${this.name} (${this.season.name})`;
        }

        return this.name;
    }

    public clone(): IdentityTeamRoster {
        const clone: IdentityTeamRoster = new IdentityTeamRoster();
        clone.id = this.id;
        clone.identityTeamId = this.identityTeamId;
        clone.name = this.name;

        if (this.athletes) {
            clone.athletes = this.athletes.map((a: IdentityPerson) => a.clone());
        }

        if (this.season) {
            clone.season = this.season.clone();
        }

        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'team';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;

        const seasonId: string = (this.season && this.season.id) || null;
        json.data.relationships = {};

        const season: any = {};
        season.data = { type: 'season', id: seasonId };
        json.data.relationships.season = season;

        return JSON.stringify(json);
    }

    /**
     * Deserialize to json api format
     */
    public deserialize(json: Object, included: Object[], identitySportName: string): IdentityTeamRoster {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        included = included || json['included'];
        const relationships: Object[] = data['relationships'] || [];

        this.id = data['id'];
        this.name = attrs['name'];
        this.identityTeamId = attrs['teamId'];

        const athleteLinks: Object = relationships['athletes'];
        if (athleteLinks &&
            included &&
            athleteLinks['data']) {
            this.athletes = [];

            for (const personLink of athleteLinks['data']) {
                const identityPerson: Object = included.filter((i: Object) => i['id'] === personLink['id'])[0];
                if (identityPerson) {
                    this.athletes.push((new IdentityPerson()).deserialize(identityPerson, included, identitySportName));
                }
            }
        }

        const seasonLink: Object = relationships['season'];
        if (seasonLink &&
            included &&
            seasonLink['data'] &&
            seasonLink['data']['id']) {
            const seasonId: string = seasonLink['data']['id'];
            const seasons: Object[] = included.filter((i: Object) => i['type'] === 'season' && i['id'] === seasonId);

            if (seasons.length === 1) {
                this.season = (new IdentitySeason()).deserialize(seasons[0], included);
            }
        } else if (attrs['seasonId']) {
            this.season = new IdentitySeason();
            this.season.id = attrs['seasonId'];
        }

        return this;
    }
}
